import { useHistory } from 'contexts/HistoryProvider/HistoryProvider';
import { useMemo } from 'react';
import { PATHS } from 'constants/paths';

export const useShowBackButton = () => {
  const { routeHistory } = useHistory();

  return useMemo(() => {
    const [previousUrl] = routeHistory.slice(-1);
    return Boolean(
      previousUrl && previousUrl !== PATHS.PRODUCTS_SEARCH && previousUrl.match(/\/products\/.+/),
    );
  }, []);
};
